import { render, staticRenderFns } from "./IconSvgSnmmiNuclearMedicineJournals.vue?vue&type=template&id=202ac22e&scoped=true&"
import script from "./IconSvgSnmmiNuclearMedicineJournals.vue?vue&type=script&lang=js&"
export * from "./IconSvgSnmmiNuclearMedicineJournals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202ac22e",
  null
  
)

export default component.exports